// The one initials-and-colour algorithm. Cards, table cells and consuming apps all route through
// here so the same person gets the same two letters and the same colour on every surface.

const _avatarPalette = [
    "#2563eb",
    "#7c3aed",
    "#db2777",
    "#dc2626",
    "#ea580c",
    "#ca8a04",
    "#16a34a",
    "#0891b2",
    "#475569"
];

// Two letters from the first two words, or the first two letters of a single word. Splits on
// punctuation and symbols so emails ("jane.doe@x.com" -> "JD") and names both work.
function getInitialsFromText(value) {
    if (!value) return "";
    const text = value.toString().trim();
    if (!text) return "";
    const words = text.split(/[\s\p{P}\p{S}]+/u).filter(word => word.length > 0);
    if (words.length === 0) return "";
    if (words.length === 1) {
        return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[1][0]).toUpperCase();
}

// Deterministic colour for a seed, so an avatar never changes colour between renders or surfaces.
// Seed on something unique per person (an email) rather than a display name, or two people with the
// same name collide.
function getAvatarColor(seed) {
    if (!seed) return _avatarPalette[0];
    const value = seed.toString();
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = ((hash << 5) - hash) + value.charCodeAt(i);
        hash |= 0;
    }
    return _avatarPalette[Math.abs(hash) % _avatarPalette.length];
}

export { getAvatarColor, getInitialsFromText };
